import { format } from 'date-fns'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

let sort_ = (schedules) => schedules.sort((a, b) => new Date(a.start) - new Date(b.start))
let date_ = (datetime) => datetime.split(' ')[0]
let time_ = (datetime) => datetime.split(' ')[1]
const date_range = (start, end) => moment.range(moment(start, 'YYYY-MM-DD'), moment(end, 'YYYY-MM-DD'))
const appendToDate = (date, a, s, e, r) => {
  var rtrn = [ ...r ],
      schedule = {
        _start: `${date} ${s}`,
        _end: `${date} ${e}`,
        ...a
      },
      exist = rtrn.find(el => el.date === date) || false,
      schedules_ = exist.schedules || []
  schedules_.push({ ...schedule })
  let new_ = { date, schedules: schedules_ }
  if (exist) {
    exist = new_
  } else {
    rtrn.push(new_)
  }
  return rtrn
}

export class Launches {
  constructor (schedules, employees, filters) {
    this.schedules = [ ...schedules ]
    this.employees = [ ...employees ]
    this.filters = {
      date: filters.date || format(new Date(), 'yyyy-MM-dd')
    }
  }

  /* INTERNAS */

  _getSchedulesDates () {
    let rtrn = [],
        schedules = [ ...this.schedules ].filter(sch => sch.status <= 2)
    schedules.forEach(a => {
      let days = Array.from(
        date_range(
          date_(a.start),
          date_(a.end)
        ).by('day')
      ).map(el => format(new Date(el), 'yyyy-MM-dd'))
      days.forEach((date, i_) => {
        let start = (i_ === 0 ? time_(a.start) : '00:00:00'),
            end = (i_ === (days.length - 1) ? time_(a.end) : '23:59:59')
        rtrn = appendToDate(date, a, start, end, rtrn)
      })
    }, [])
    return rtrn
  }

  /* ... */

  get (flatten = false) {
    let schedules = this._getSchedulesDates() || []
    if (flatten) {
      schedules = schedules.reduce((add, val) => add.concat(val.schedules), [])
      return sort_(schedules)
    } else {
      let date = schedules.find(dt => dt.date === this.filters.date) || false,
          filtered = (date ? date.schedules || [] :  [])
  
      filtered = sort_(filtered)
  
      return this.employees.map(emp => {
        let schedules = filtered.filter(sch => (sch.employees || []).findIndex(emp_ => emp_ === emp.id) >= 0),
            lines = schedules.reduce((add, val) => {
              let same_hour = schedules
                .filter(el => (new Date(el._start)).getHours() === (new Date(val._start)).getHours())
                .length
              return (add < same_hour ? same_hour : add)
            }, 0)
        return {
          ...emp,
          status: (schedules.length > 0 ? emp.working : 0),
          schedules,
          lines
        }
      })
    }
  }

}
